// Klinik profilleri ve terim setleri — etiketler. Modül kataloğu ve profil
// içerikleri sunucudan gelir (GET .../modules/get → catalog, profiles).
// Sunucu karşılığı: Pupill-IOT-Server/src/shared/permissions/clinic-modules.config.js

// Klinik türleri çoklu seçilir (2026-10-07); eski "Karma" = üçü birden.
export const PROFILE_KEYS = ["dietitian", "modern", "traditional"];

export const PROFILE_LABELS = {
  dietitian: "Diyetisyen",
  modern: "Modern Tıp",
  traditional: "Geleneksel Tıp",
};

export const PROFILE_OPTIONS = PROFILE_KEYS.map((value) => ({
  value,
  label: PROFILE_LABELS[value],
}));

export const TERM_SET_OPTIONS = [
  { value: "clinical", label: "Hasta / Muayene / Doktor" },
  { value: "wellness", label: "Danışan / Görüşme / Uzman" },
];

/** Seçili türlerin okunur adı: "Diyetisyen + Geleneksel Tıp" (boşsa null). */
export const profilesLabel = (profiles) => {
  const list = PROFILE_KEYS.filter((k) => (profiles || []).includes(k));
  return list.length ? list.map((k) => PROFILE_LABELS[k]).join(" + ") : null;
};

/**
 * Bir modülü açar; gerektirdiği modülleri de (zincirle) açar.
 * @returns {{ next: string[], added: string[] }} added = kullanıcının seçmediği, kendiliğinden açılanlar
 */
export function enableModule(enabled, key, catalog) {
  const byKey = Object.fromEntries(catalog.map((m) => [m.key, m]));
  const next = new Set(enabled);
  const added = [];
  const visit = (k) => {
    if (next.has(k)) return;
    next.add(k);
    if (k !== key) added.push(k);
    (byKey[k]?.requires || []).forEach(visit);
  };
  visit(key);
  return { next: catalog.map((m) => m.key).filter((k) => next.has(k)), added };
}

/**
 * Bir modülü kapatır; ona bağlı açık modülleri de (zincirle) kapatır.
 * Kilitli (çekirdek) modüller kapanmaz.
 * @returns {{ next: string[], removed: string[] }} removed = kendiliğinden kapananlar
 */
export function disableModule(enabled, key, catalog) {
  const next = new Set(enabled);
  const removed = [];
  const visit = (k) => {
    if (!next.has(k) || catalog.find((m) => m.key === k)?.locked) return;
    next.delete(k);
    if (k !== key) removed.push(k);
    catalog.filter((m) => (m.requires || []).includes(k)).forEach((m) => visit(m.key));
  };
  visit(key);
  return { next: catalog.map((m) => m.key).filter((k) => next.has(k)), removed };
}
